import { render } from "./MethodAssessmentIntroPage.vue?vue&type=template&id=988c1296"
import script from "./MethodAssessmentIntroPage.vue?vue&type=script&lang=js"
export * from "./MethodAssessmentIntroPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__